import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/maintain/rec/machine`,
    name: 'MAINTAIN_RECOVER_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
